import * as React from "react";
const FormFieldSpinnerDown = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 8 5", fill: "currentColor", width: size || "8", height: size || "5", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M4 3.2.7 0 0 .8 4 4.8 8 .8 7.2 0z" }));
FormFieldSpinnerDown.displayName = "FormFieldSpinnerDown";
var FormFieldSpinnerDown_default = FormFieldSpinnerDown;
export {
  FormFieldSpinnerDown_default as default
};
